import english from '../en/cinema';

export default {
  ...english,
  cinema_referral: "共有で稼ぐ",
  cinema_referralDesc: "個人用リンクで友だちを招待し、報酬を獲得しよう",
  cinema_referralLinkTitle: "私の紹介リンク",
  cinema_referralLinkDesc: "このリンク経由での新規登録はすべてあなたに帰属します",
  cinema_referralRulesTitle: "紹介ルール",
  cinema_referralRulesCoins: "友だちがあなたの紹介リンクから登録すると、コイン報酬を受け取ることができます。コインはプラットフォームでコンテンツを視聴する際にのみ使用でき、現金への交換や出金はできません。",
  cinema_referralRulesCommission: "友だちがチャージすると、適用されるルールに基づき手数料を獲得できます。出金可能なのはチャージ手数料のみで、金額が¥100に達した時点でUSDTの出金を申請できます。",
  cinema_copyLink: "リンクをコピー",
  cinema_inviteCodeLabel: "紹介コード",
  cinema_inviteRuleTitle: "紹介報酬",
  cinema_inviteRuleNormal: "会員は、正常に登録されたたびに20コインを獲得します。報酬はコイン履歴に記録されます。",
  cinema_distributorOverview: "ディストリビューター概要",
  cinema_availableCommission: "利用可能",
  cinema_totalCommission: "合計手数料",
  cinema_pendingWithdrawal: "出金保留中",
  cinema_withdrawnAmount: "出金済み",
  cinema_firstLevelRate: "レベル1レート",
  cinema_secondLevelRate: "レベル2レート",
  cinema_todayBrowse: "再生回数",
  cinema_todayRegister: "登録数",
  cinema_todayRecharge: "チャージ回数",
  cinema_todayRechargeAmount: "チャージ金額",
  cinema_commissionAmount: "手数料",
  cinema_registerDetails: "登録数",
  cinema_rechargeDetails: "チャージ回数",
  cinema_inviteRewards: "紹介報酬",
  cinema_goWithdraw: "出金",
  cinema_noReferralData: "まだ紹介データがありません",
  cinema_referralLoadFailed: "紹介データを読み込めません。もう一度お試しください。",
  cinema_loginToPromote: "サインインして紹介リンクを作成しましょう",
  cinema_totalEarnings: "合計獲得額",
  cinema_withdrawable: "出金可能",
  cinema_frozen: "凍結中",
  cinema_invitedCount: "招待済み",
  cinema_coinUnit: "コイン",
  cinema_people: "人数",
  cinema_conversionStats: "紹介コンバージョン",
  cinema_allDatesTotal: "全期間合計",
  cinema_selectedDatesTotal: "選択した日付の合計",
  cinema_conversionStatsDesc: "日別の再生回数、登録数、チャージ回数および手数料",
  cinema_colDate: "日付",
  cinema_colPv: "訪問者数",
  cinema_colBrowseCount: "閲覧数",
  cinema_colRegister: "会員登録数",
  cinema_colRechargeUsers: "支払いユーザー数",
  cinema_colRechargeOrders: "注文数",
  cinema_colPaidAmount: "支払総額",
  cinema_colCommission: "手数料",
  cinema_colRegisterRate: "会員登録率",
  cinema_colRechargeRate: "リチャージ率",
  cinema_commissionRateTitle: "手数料率",
  cinema_currentRateLabel: "現在の実際の手数料率",
  cinema_baseRate: "基本料金",
  cinema_currentRate: "現行料金",
  cinema_earningsRecord: "収益記録",
  cinema_inviteDetail: "招待詳細",
  cinema_allEarnings: "全収益",
  cinema_filterAll: "全て",
  cinema_filterPending: "保留中",
  cinema_filterSettled: "決済済み",
  cinema_earningsDate: "日付",
  cinema_earningsType: "タイプ",
  cinema_earningsUser: "ユーザー",
  cinema_earningsAmount: "収益",
  cinema_earningsStatus: "ステータス",
  cinema_statusSettled: "決済済み",
  cinema_statusPending: "保留中",
  cinema_noEarningsRecords: "まだ記録がありません",
  cinema_referralUser: "ユーザー",
  cinema_referralRegDate: "登録日",
  cinema_referralRecharged: "合計リチャージ額",
  cinema_referralEarned: "私の収益",
  cinema_startDate: "開始日",
  cinema_endDate: "終了日",
  cinema_query: "検索",
  cinema_dateRangeError: "開始日は終了日より後であってはなりません",
  cinema_brand: "Huangguo TV",
  cinema_language: "言語",
  cinema_tagline: "AIオリジナルショートドラマ",
  cinema_navHome: "ホーム",
  cinema_navCategories: "ランキング",
  cinema_rankingTitle: "ランキング",
  cinema_rankingAll: "すべて",
  cinema_rankingLoading: "ランキングを読み込み中…",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} 本のシリーズ · {{views}} 回の視聴",
  cinema_rankingTotal: "過去最高",
  cinema_rankingMonth: "月間",
  cinema_rankingWeek: "週間",
  cinema_rankingLatest: "最新",
  cinema_rankingCreator: "クリエイター",
  cinema_creatorLabel: "クリエイター",
  cinema_rankingEmpty: "まだランキングに登録されたシリーズはありません",
  cinema_navMyList: "人気",
  cinema_soundGuideTitle: "タップして音声をオンにする",
  cinema_soundGuideAction: "音声をオンにする",
  cinema_soundGuideDismiss: "音声ガイドを閉じる",
  cinema_navHistory: "履歴",
  cinema_navAds: "コイン",
  cinema_adsTitle: "注目の広告",
  cinema_adsSubtitle: "注目のコンテンツをさらに見つける",
  cinema_adFeatured: "注目",
  cinema_adOpen: "今すぐ視聴",
  cinema_adsEmpty: "広告がありません",
  cinema_adsLoadFailed: "広告を読み込めません。もう一度お試しください。",
  cinema_earnTitle: "コインを獲得",
  cinema_earnSubtitle: "毎日チェックインしてコインを集めよう",
  cinema_earnBalance: "マイコイン",
  cinema_checkInTitle: "毎日チェックイン",
  cinema_checkInSubtitle: "ストリークをキープして、さらに多くのコインを獲得しよう",
  cinema_checkInDay: "{{day}}日目",
  cinema_checkInToday: "今日",
  cinema_checkInClaim: "{{points}}コイン分のチェックインをしよう",
  cinema_checkInClaimed: "今日はチェックイン済み",
  cinema_checkInLogin: "ログインしてチェックインしよう",
  cinema_checkInSuccess: "チェックイン完了。{{points}}コインを獲得しました",
  cinema_checkInFailed: "チェックインに失敗しました。接続状況を確認し、もう一度お試しください",
  cinema_checkInNoReward: "この端末はすでに今日のチェックイン報酬を受け取りました",
  cinema_checkInStreak: "現在のストリーク",
  cinema_checkInStreakValue: "{{days}}日間",
  cinema_checkInTotal: "合計獲得数",
  cinema_checkInTotalValue: "{{points}}コイン",
  cinema_checkInLoadFailed: "チェックイン状況の読み込みに失敗しました",
  cinema_retry: "もう一度試す",
  cinema_moreEarnWays: "獲得方法をもっと見る",
  cinema_inviteEarnTitle: "友だちを招待して獲得",
  cinema_inviteEarnDesc: "友だちが登録するとコインを獲得",
  cinema_goInvite: "招待する",
  cinema_earnCoinsTitle: "コインを獲得",
  cinema_earnCoinsBalance: "私のコイン",
  cinema_earnCoinsSignInStreak: "{{count}}日間チェックインしました",
  cinema_earnCoinsCheckIn: "チェックイン",
  cinema_earnCoinsCheckedIn: "チェックイン済み",
  cinema_earnCoinsTomorrow: "明日また来てください",
  cinema_earnCoinsInviteTitle: "友だちを招待して獲得",
  cinema_earnCoinsInviteCode: "私の招待コード",
  cinema_earnCoinsGoInvite: "今すぐ招待",
  cinema_earnCoinsLimitedTask: "限定タスク",
  cinema_earnCoinsTimeLeft: "カウントダウン",
  cinema_earnCoinsNewbieTask: "新規ユーザー向けタスク",
  cinema_earnCoinsDailyTask: "日常タスク",
  cinema_earnCoinsRecommendations: "おすすめ",
  cinema_earnCoinsAdTask: "広告を見る",
  cinema_earnCoinsAdTaskDesc: "広告を見てさらにコインを獲得",
  cinema_earnCoinsGoWatch: "広告を見る",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "{{day}}日目",
  cinema_earnCoinsToday: "今日",
  cinema_earnCoinsCoinUnit: "コイン",
  cinema_earnCoinsAdCurrent: "現在のタスク",
  cinema_earnCoinsAdLocked: "鍵がかかっているタスク",
  cinema_earnCoinsTaskCompleted: "完了",
  cinema_limitedRechargeTaskTitle: "最初のチャージを1時間以内に完了してください",
  cinema_limitedRechargeTaskAction: "チャージ",
  cinema_claimReward: "請求",
  cinema_claiming: "請求中",
  cinema_taskClaimFailed: "請求に失敗しました。もう一度お試しください。",
  cinema_bindEmailAction: "メールアドレスを連携",
  cinema_limitedRechargeTaskExpired: "期限切れ",
  cinema_watchHistory: "視聴履歴",
  cinema_navSearch: "シリーズを検索…",
  cinema_login: "ログイン",
  cinema_vip: "チャージ",
  cinema_heroPlay: "今すぐ再生",
  cinema_heroMore: "詳細を見る",
  cinema_hotRecommend: "今話題の作品",
  cinema_carouselLoading: "注目のコンテンツを読み込み中…",
  cinema_newRelease: "新作リリース",
  cinema_allSeries: "全てのシリーズ",
  cinema_viewAll: "すべて表示",
  cinema_episodes: "{{count}} エピソード",
  cinema_rating: "{{score}} の評価",
  cinema_views: "{{count}} 回視聴",
  cinema_play: "再生",
  cinema_continueWatch: "視聴を続ける",
  cinema_rewatch: "再視聴",
  cinema_categoryAll: "すべて",
  cinema_categoryUrban: "アーバンロマンス",
  cinema_categorySuspense: "サスペンス",
  cinema_categoryCostume: "歴史もの",
  cinema_categoryWorkplace: "職場もの",
  cinema_categorySciFi: "SF",
  cinema_categorySciFiRomance: "SFロマンス",
  cinema_unlock: "エピソードを解除",
  cinema_unlockDesc: "このエピソードの解除には {{cost}} コインが必要です",
  cinema_unlockConfirm: "確認して再生",
  cinema_cancel: "キャンセル",
  cinema_balance: "残高：{{coins}} コイン",
  cinema_insufficient: "コインが不足しています。チャージしてください",
  cinema_unlocked: "解除済み",
  cinema_locked: "鍵がかかっています",
  cinema_episodeNumber: "エピソード {{number}}",
  cinema_playing: "ただいま再生中",
  cinema_backToList: "一覧に戻る",
  cinema_back: "戻る",
  cinema_noSeries: "利用可能なシリーズはありません",
  cinema_seriesDesc: "あらすじ",
  cinema_episodeList: "エピソード",
  cinema_nextEpisode: "次へ",
  cinema_episodeEnded: "エピソード終了",
  cinema_nextEpisodePrompt: "エピソード {{number}} で続行しますか？",
  cinema_playNextEpisode: "次のエピソードを再生",
  cinema_prevEpisode: "前へ",
  cinema_freeLabel: "無料",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "新作",
  cinema_hotLabel: "人気",
  cinema_featuredBanner: "今週必ず見るべき作品",
  cinema_watchNow: "今すぐ視聴",
  cinema_searchPlaceholder: "作品を検索",
  cinema_noResults: "見つかるシリーズはありません",
  cinema_emptyMyList: "お気に入りリストにまだ何もありません",
  cinema_emptyHistory: "視聴履歴がありません",
  cinema_addToMyList: "お気に入りに追加",
  cinema_removeFromMyList: "お気に入りから削除",
  cinema_clearAll: "全てクリア",
  cinema_footerCopy: "黄国TV — プレミアム短編ドラマプラットフォーム",
  cinema_footerWarning: "コンテンツは娯楽目的でAI生成されています。各地の法令を遵守してください。",
  cinema_myList: "お気に入り",
  cinema_addedAt: "追加日時：{{date}}",
  cinema_expand: "展開",
  cinema_collapse: "折りたたみ",
  cinema_historyAll: "すべて",
  cinema_historyUnfinished: "未完了",
  cinema_historyFinished: "完了",
  cinema_historyCount: "{{count}}件の記録",
  cinema_noHistoryFilter: "このカテゴリには記録がありません",
  cinema_finished: "完了",
  cinema_watchedFull: "完了済み",
  cinema_welcomeBack: "おかえりなさい",
  cinema_loginDesc: "ログインしてさらにコンテンツを解除しましょう",
  cinema_phoneLogin: "電話番号でログイン",
  cinema_emailLogin: "メールアドレスでログイン",
  cinema_phonePlaceholder: "電話番号を入力",
  cinema_emailPlaceholder: "メールアドレスを入力",
  cinema_agreeTerms: "ログインすることで、以下の内容に同意したものとみなされます",
  cinema_userAgreement: "利用規約",
  cinema_privacyPolicy: "プライバシーポリシー",
  cinema_getCode: "コードを取得",
  cinema_loginNow: "今すぐログイン",
  cinema_otherLogin: "その他のログイン方法",
  cinema_loggingIn: "ログイン中…",
  cinema_loginSuccess: "ログインに成功しました",
  cinema_loginRedirect: "プロフィールへリダイレクト中...",
  cinema_profile: "プロフィール",
  cinema_memberLabel: "会員",
  cinema_dealerLabel: "代理店",
  cinema_coinAmount: "{{count}} コイン",
  cinema_profileAccount: "アカウント",
  cinema_profileContent: "コンテンツ",
  cinema_profileSettings: "設定",
  cinema_editProfile: "プロフィールを編集",
  cinema_myCoins: "マイコイン",
  cinema_myPurchases: "購入済み",
  cinema_downloads: "ダウンロード",
  cinema_playbackSettings: "再生設定",
  cinema_notifications: "通知",
  cinema_cacheManage: "キャッシュ管理",
  cinema_about: "お問い合わせ",
  cinema_contactUnavailable: "カスタマーサービスは現在ご利用いただけません。後ほど再度お試しください。",
  cinema_watchedHours: "視聴時間",
  cinema_collectionCount: "コレクション",
  cinema_logout: "ログアウト",
  cinema_logoutConfirm: "ログアウトを確認しますか？",
  cinema_logoutConfirmDesc: "全機能をご利用いただくには、再度ログインが必要です",
  cinema_version: "バージョン {{version}}",
  cinema_rechargeTitle: "リチャージ",
  cinema_rechargeSubtitle: "リチャージプランを選択してください",
  cinema_rechargeVpnWarning: "VPNやプロキシが支払いリスク管理の対象となり、決済画面が開かない、または決済が失敗する可能性があります。",
  cinema_rechargeVpnGuideTitle: "支払い前にVPNをオフにしてください",
  cinema_rechargeVpnInstruction: "VPNをオフにした後、下のボタンをクリックして選択した支払い方法で続行してください。",
  cinema_rechargeVpnContinue: "VPNはオフです。支払いを続ける",
  cinema_rechargeRMB: "RMBリチャージ",
  cinema_rechargeUSDT: "USDTリチャージ",
  cinema_rechargeRecommended: "おすすめ",
  cinema_rechargeCoins: "コイン",
  cinema_rechargeBonus: "+{{points}} のボーナス",
  cinema_rechargeCredited: "{{points}} を獲得",
  cinema_firstRechargeBannerTitle: "初回リチャージボーナス！ 金額に関わらず追加報酬あり",
  cinema_firstRechargeSelectedBonus: "+{{points}} コイン",
  cinema_firstRechargeLimitedTitle: "限定の初回リチャージボーナス",
  cinema_dailyRechargeLimitedTitle: "限定のリチャージボーナス",
  cinema_firstRechargeLimitedBonus: "金額に関わらず {{percent}}% の追加ボーナス",
  cinema_rechargePayMethod: "支払い方法",
  cinema_rechargePay: "支払う",
  cinema_rechargeNoPackages: "現在、リチャージプランは利用できません",
  cinema_paymentUnavailable: "現在、決済はご利用いただけません。サポートまでご連絡ください。",
  cinema_follow: "フォロー",
  cinema_collect: "集める",
  cinema_share: "共有",
  cinema_loading: "読み込み中...",
  cinema_favorites: "お気に入り",
  cinema_emptyFavorites: "まだお気に入りのシリーズはありません",
  cinema_emptyPurchases: "まだ購入したシリーズはありません",
  cinema_clearAllConfirm: "鑑賞履歴をすべてクリアしますか？",
  cinema_episodesUnit: "エピソード",
  cinema_lastWatched: "最後に視聴したエピソード {{episode}}",
  cinema_purchasedEpisodes: "{{count}} エピソードが解除されました",
  cinema_account: "アカウント",
  cinema_accountName: "表示名",
  cinema_accountEmail: "メールアドレス",
  cinema_shareCode: "共有コード",
  cinema_saveProfile: "プロフィールを保存",
  cinema_profileSaved: "プロフィールが保存されました",
  cinema_profileSaveFailed: "プロフィールの保存に失敗しました",
  cinema_accountInfo: "基本情報",
  cinema_changePassword: "パスワードを変更",
  cinema_newPassword: "新しいパスワード",
  cinema_confirmPassword: "新しいパスワードの確認",
  cinema_passwordHint: "少なくとも6文字以上を使用してください",
  cinema_passwordMismatch: "パスワードが一致しません",
  cinema_passwordSaved: "パスワードが更新されました",
  cinema_passwordSaveFailed: "パスワードの更新に失敗しました",
  cinema_savePassword: "パスワードを保存",
  cinema_pointsBalance: "コイン残高",
  cinema_coinLedger: "コイン台帳",
  cinema_businessReference: "参考",
  cinema_emptyPointLogs: "まだコインの履歴がありません",
  cinema_pointLog_registerReward: "登録特典",
  cinema_pointLog_appFirstLoginReward: "初回アプリログイン特典",
  cinema_pointLog_inviteReward: "招待特典",
  cinema_pointLog_dailyCheckIn: "日常チェックイン特典",
  cinema_pointLog_limitedRechargeTask: "限定初回リチャージタスク特典",
  cinema_pointLog_emailBindingTask: "メールアドレス登録タスク特典",
  cinema_pointLog_dailyUnlockTask: "日常エピソード解除タスク特典",
  cinema_bindEmailTaskTitle: "メールアドレスを連携",
  cinema_dailyUnlockTaskTitle: "新しいエピソードを{{count}}話解放",
  cinema_unlockAction: "解放する",
  cinema_dailyTaskProgress: "本日の進捗 {{current}}/{{target}}（第1話は対象外）",
  cinema_pointLog_firstEpisodeUnlock: "最初のエピソードのパス解除",
  cinema_pointLog_episodeUnlock: "エピソードの解除",
  cinema_pointLog_recharge: "リチャージが反映されました",
  cinema_pointLog_firstRechargeBonus: "初回リチャージボーナス",
  cinema_pointLog_dailyRechargeBonus: "限定リチャージボーナス",
  cinema_pointLog_adminAdjust: "管理者による調整",
  cinema_pointLog_other: "コインの変更",
  cinema_pointBiz_register: "登録",
  cinema_pointBiz_registerBackfill: "登録報酬の補填",
  cinema_pointBiz_appFirstLogin: "初回アプリログイン",
  cinema_pointBiz_inviteRegister: "招待による登録",
  cinema_pointBiz_dailyCheckIn: "日常チェックイン",
  cinema_pointBiz_legacyLimitedRechargeTask: "24時間リチャージタスク",
  cinema_pointBiz_limitedRechargeTask: "1時間の初回リチャージタスク",
  cinema_pointBiz_emailBindingTask: "メールアドレスの紐付けタスク",
  cinema_pointBiz_unlockThreeEpisodes: "毎日3エピソード解除タスク",
  cinema_pointBiz_unlockFiveEpisodes: "毎日5エピソード解除タスク",
  cinema_pointBiz_episodeUnlock: "エピソードの解除",
  cinema_pointBiz_rechargeOrder: "リチャージ注文",
  cinema_pointBiz_adminAdjust: "管理者による調整",
  cinema_pointBiz_other: "その他の業務",
  cinema_playbackAutoplay: "次回エピソードの自動再生",
  cinema_playbackAutoplayDesc: "エピソード終了時に自動で次へ進む",
  cinema_aboutDesc: "「マイファンタジー」は、常に最新の短編ドラマコンテンツをお届けします。",
  cinema_rechargeOrders: "リチャージ台帳",
  cinema_myRechargeRecords: "自分のリチャージ記録を確認する",
  cinema_totalInvites: "合計招待数",
  cinema_distributionStats: "プロモーション統計",
  cinema_distributionStatsDesc: "日付別に閲覧数、登録数、リチャージ数、手数料を確認する",
  cinema_summaryDate: "日付",
  cinema_summaryBrowse: "閲覧数",
  cinema_summaryRegister: "登録数",
  cinema_summaryRechargeCount: "リチャージ数",
  cinema_conversionRate: "成約率",
  cinema_commissionRatio: "手数料比率",
  cinema_browseDetails: "詳細を表示する",
  cinema_browseTime: "表示時間",
  cinema_browseDrama: "ドラマ",
  cinema_browseRegion: "地域",
  cinema_noBrowseData: "閲覧記録はまだありません",
  cinema_noSummaryData: "まだサマリーデータがありません",
  cinema_rewarded: "リワード済み",
  cinema_registered: "登録済み",
  cinema_close: "閉じる",
  cinema_emptyRechargeOrders: "まだチャージ記録がありません",
  cinema_rechargeRecords: "チャージ台帳",
  cinema_commissionRecords: "手数料台帳",
  cinema_rechargeTime: "チャージ時間",
  cinema_paymentMethod: "支払い方法",
  cinema_paymentStatus: "支払い状況",
  cinema_orderNo: "注文番号",
  cinema_noRechargeRecords: "まだチャージ記録がありません",
  cinema_commissionTime: "手数料時間",
  cinema_commissionLevel: "手数料レベル",
  cinema_commissionRate: "手数料率",
  cinema_noCommissionRecords: "まだ手数料記録がありません",
  cinema_search: "検索",
  cinema_reset: "リセット",
  cinema_previousPage: "前へ",
  cinema_nextPage: "次へ",
  cinema_paymentStatus_created: "作成済み",
  cinema_paymentStatus_pending: "支払い待ち",
  cinema_paymentStatus_paid: "チャージ完了",
  cinema_paymentStatus_failed: "支払い失敗",
  cinema_paymentStatus_closed: "終了",
  cinema_paymentStatus_expired: "期限切れ",
  cinema_paymentAwaiting: "注文が作成されました。支払いページで決済を完了してください。決済に失敗した場合は、VPNがオフになっているかご確認ください。",
  cinema_usdtAddress: "受取アドレス",
  cinema_usdtNetwork: "TRC20ネットワークのみ対応",
  cinema_copy: "コピー",
  cinema_copied: "コピー済み",
  cinema_playerSettings: "再生設定",
  cinema_playerQuality: "品質",
  cinema_playerSpeed: "再生速度",
  cinema_playerAuto: "自動",
  cinema_playerSource: "元の画質",
  cinema_playerSubtitles: "字幕",
  cinema_subtitleAuto: "自動字幕",
  cinema_subtitleOff: "字幕なし",
  cinema_appDownloadTitle: "アプリで次のエピソードをより確実に視聴できます",
  cinema_appDownloadDesc: "進捗を記憶し、アップデートのお知らせを受け取りましょう。",
  cinema_appDownloadReward: "アプリをダウンロードして、初回ログインで{{points}}ポイントのボーナスコインをゲット！",
  cinema_homeAppDownloadReward: "アプリでログインすると、{{points}}ポイントのボーナスコインがもらえます！",
  cinema_shareEarnPoints: "シェアして稼ごう",
  cinema_shareLinkLabel: "リンクをシェア",
  cinema_shareRewardUnlimited: "自分のリンクから新規ユーザーが参加するたびに、上限なしで{{points}}ポイントのコインを獲得できます！",
  cinema_loginForShareLink: "ログインしてシェアリンクを取得",
  cinema_viewReferralStats: "参照統計を確認",
  cinema_episodeFinished: "エピソード終了",
  cinema_unlockNextEpisode: "次のエピソードを解除",
  cinema_changeDrama: "動画を変更",
  cinema_allUnlocked: "すべて解除済み",
  cinema_appDownloadButton: "アプリをダウンロード",
  cinema_appDownloadUnavailable: "現在はダウンロードできません",
  cinema_rechargeAppPromptTitle: "ボーナスコイン獲得のためにアプリをダウンロードしよう",
  cinema_rechargeAppPromptReward: "ダウンロードしてログインすれば、{{points}}ポイントの追加コインがもらえます！",
  cinema_rechargeAppPromptDesc: "アプリでは、より安定した再生と視聴進捗の自動保存をお楽しみいただけます。",
  cinema_appDownloadQr: "スキャンしてアプリをダウンロード",
  cinema_ageGateBadge: "年齢認証",
  cinema_ageGateTitle: "成人向けコンテンツに関する注意",
  cinema_ageGateDescription: "本サイトには成人向けのフィクションAI生成コンテンツが含まれています。続行することで、お客様が少なくとも18歳以上であり、居住地の法令を遵守することに同意することを確認します。",
  cinema_ageGateUnderage: "18歳未満の方は、ただちに本サイトから退出してください。",
  cinema_ageGateConfirm: "私は18歳以上です — サイトへ入る",
  cinema_creatorCenter: "クリエイター",
  cinema_creatorCenterDesc: "自分の物語を創り、世界を共有しよう",
  cinema_creatorCenterNote: "注意：非オリジナル作品には透かしを入れてください",
  cinema_creatorMemberReady: "VIP会員です。ワンクリックで申請可能",
  cinema_creatorBecome: "クリエイターになろう",
  cinema_creatorGateDesc: "自分の物語を黄果TVに届けましょう。承認後、映画館で公開され、数百万もの視聴者に才能を披露し、プレミアムサブスクリプション収益の分配を得ることができます。",
  cinema_creatorApplyBtn: "クリエイターへの応募",
  cinema_creatorBenefitTitle: "クリエイター特典",
  cinema_creatorBenefit1: "作品に専用の「オリジナル」タグを付けて掲載",
  cinema_creatorBenefit2: "再生数、登録数、収益分配をリアルタイムで確認",
  cinema_creatorBenefit3: "さらに多くの創作ツールやプロモーションリソースを解放",
  cinema_creatorReviewTip: "応募および作品はプラットフォームにより審査され、コミュニティガイドラインに従う必要があります。",
  cinema_creatorLevel: "認証済みクリエイター",
  cinema_creatorOriginal: "オリジナル",
  cinema_creatorSince: "クリエイター歴",
  cinema_creatorAddWork: "新作をアップロード",
  cinema_creatorTabOverview: "概要",
  cinema_creatorTabWorks: "私の作品",
  cinema_creatorTabUpload: "アップロード",
  cinema_creatorTabPlatform: "スタジオ",
  cinema_creatorSubmitted: "提出済み、審査待ち",
  cinema_creatorStatViews: "総再生回数",
  cinema_creatorStatSubs: "総チャンネル登録者数",
  cinema_creatorStatRevenue: "総収益",
  cinema_creatorStatWithdraw: "引き出し可能",
  cinema_creatorStatWorks: "作品",
  cinema_creatorStatReview: "審査中",
  cinema_creatorStatRejected: "拒否",
  cinema_creatorTopWork: "最も好評な作品",
  cinema_creatorViews: "再生回数",
  cinema_creatorSubscriptions: "登録者数",
  cinema_creatorShare: "収益",
  cinema_creatorNoPublished: "まだ公開された作品はありません",
  cinema_creatorFilterPublished: "公開済み",
  cinema_creatorFilterReview: "審査中",
  cinema_creatorFilterRejected: "拒否",
  cinema_creatorWorksTitle: "私の作品",
  cinema_creatorNoWorks: "まだ作品がありません。最初の作品をアップロードしましょう",
  cinema_creatorGoUpload: "今すぐアップロード",
  cinema_creatorStatusPublished: "公開済み",
  cinema_creatorStatusReview: "審査中",
  cinema_creatorStatusApproved: "変換待ち",
  cinema_creatorStatusTranscoding: "変換中",
  cinema_creatorStatusReady: "公開待ち",
  cinema_creatorStatusTranscodeFailed: "変換失敗",
  cinema_creatorStatusPublishFailed: "公開失敗",
  cinema_creatorStatusRejected: "拒否",
  cinema_creatorPublishedOn: "公開日時",
  cinema_creatorSubmittedOn: "提出日時",
  cinema_creatorRejectedTip: "拒否・提出日時",
  cinema_creatorWorkName: "作品タイトル",
  cinema_creatorWorkNamePh: "作品タイトルを入力してください",
  cinema_creatorCategory: "カテゴリ",
  cinema_creatorCover: "表紙",
  cinema_creatorCoverHint: "縦向きの表紙画像を1枚アップロードしてください",
  cinema_creatorCoverUrlPh: "画像リンクを貼り付けてください（任意）",
  cinema_creatorSynopsis: "あらすじ",
  cinema_creatorSynopsisPh: "あなたの物語を一、二文で説明してください…",
  cinema_creatorEpisodeTitle: "エピソード",
  cinema_creatorEpisodeDesc: "各エピソードのタイトルを追加し、MP4またはMOV動画を1本ずつアップロードしてください",
  cinema_creatorEpisodeTitlePh: "エピソードタイトル",
  cinema_creatorEpisodeDurPh: "再生時間（分）",
  cinema_creatorAddEpisode: "エピソードを追加",
  cinema_creatorEpShort: "エピソード {{count}}",
  cinema_creatorEpisodeUpload: "動画をアップロード",
  cinema_creatorEpisodeUploading: "アップロード中…",
  cinema_creatorEpisodeReplace: "動画を置き換える",
  cinema_creatorEpisodeMp4Only: ".mp4、.movファイル、1ファイルあたり最大100MBまで",
  cinema_creatorEpisodeTypeError: "各エピソードは.mp4または.mov形式の動画でなければなりません",
  cinema_creatorEpisodeSizeError: "各エピソードの動画サイズは100MB以下にしてください",
  cinema_creatorEpisodeUploadFailed: "エピソードのアップロードに失敗しました。もう一度お試しください。",
  cinema_creatorEpisodeRequired: "各エピソードのタイトルを付け、MP4またはMOV動画をアップロードしてください",
  cinema_creatorRequired: "まずタイトルを入力し、カバー画像を選んでください",
  cinema_creatorWorkNameRequired: "作品タイトルを入力してください",
  cinema_creatorCategoryRequired: "カテゴリを選択してください",
  cinema_creatorCoverRequired: "カバー画像をアップロードしてください",
  cinema_creatorEpisodeTitleRequired: "エピソードタイトルを入力してください",
  cinema_creatorEpisodeVideoRequired: "このエピソードのMP4またはMOV動画をアップロードしてください",
  cinema_creatorSubmit: "審査に提出",
  cinema_creatorPlatformTag: "クリエイターおすすめ",
  cinema_creatorPlatformTitle: "クリエーションツールプラットフォーム",
  cinema_creatorPlatformDesc: "プロ向けのツールや脚本のアイデア、素材が揃った公式クリエーションプラットフォームへ移動し、あなたの物語を形にして公開しましょう。",
  cinema_creatorPlatformPoint1: "AIによる脚本・アイデア",
  cinema_creatorPlatformPoint2: "プロ向けの作成・アップロードツール",
  cinema_creatorPlatformPoint3: "トラフィック支援と収益分配",
  cinema_creatorPlatformOpen: "クリエーションプラットフォームへ移動",
  cinema_creatorEarnBannerTitle: "あなたの物語を映画館へ",
  cinema_creatorEarnBannerDesc: "クリエイターになって作品をアップロードし、再生回数や登録者数、収益分配で稼ぎましょう",
  cinema_creatorEarnBannerBtn: "クリエイターセンターを開く",
  cinema_creatorApplyFailed: "申請に失敗しました。もう一度お試しください。",
  cinema_creatorSubmitFailed: "提出に失敗しました。もう一度お試しください。",
  cinema_creatorSubmitting: "提出中…",
  cinema_creatorCategoryEmpty: "利用可能なカテゴリがありません",
  cinema_creatorCoverUpload: "カバーをアップロード",
  cinema_creatorCoverUploading: "アップロード中…",
  cinema_creatorCoverChoose: "画像を選択",
  cinema_creatorCoverReplace: "画像を置き換える",
  cinema_creatorCoverRemove: "削除",
  cinema_creatorCoverFormat: "JPG、PNG、WebP、またはGIFで、最大10 MBまで。画像は1枚のみ。",
  cinema_creatorCoverTypeError: "JPG、PNG、WebP、またはGIFの画像を選択してください",
  cinema_creatorCoverSizeError: "カバー画像は10 MB以下にしてください",
  cinema_creatorCoverUploadFailed: "カバーのアップロードに失敗しました。もう一度お試しください。",
  cinema_creatorUploadNoticeTitle: "アップロードガイドライン",
  cinema_creatorUploadNotice1: "アップロードされたすべての素材は、オリジナルであれ他社のものであれ、透かしを含んではいけません。",
  cinema_creatorUploadNotice2: "オリジナル制作者は、著作権所有権の登録について当社のビジネスチームにお問い合わせください。",
  cinema_creatorUploadNotice3: "最終エピソードの価格設定はプラットフォームが決定します。",
  cinema_creatorUploadNotice4: "各エピソードの長さは最低150秒以上でなければなりません。",
  cinema_creatorUploadNoticeConfirm: "了解しました、続行する",
  cinema_navProfile: "マイページ",
};
